import { ReactNode } from 'react'

interface PopupBodyProps {
	children: ReactNode
	className?: string
}

const PopupBody: React.FC<PopupBodyProps> = ({ children, className = '' }) => {
	return (
		<div className={`min-h-0 flex-1 overflow-y-auto px-4 py-4 sm:px-5 sm:py-5 ${className}`.trim()}>{children}</div>
	)
}

export default PopupBody
